<template>
  <ReportLayoutModerno
    id="reportList"
    :prefecture="prefecture"
    :period="convertDate(filter.startDate) + ' até ' + convertDate(filter.endDate)"
  >
    <template v-slot:icon>mdi-receipt-text-outline</template>
    <template v-slot:title>RELATÓRIO DE NF-E</template>
    <template v-slot:sub-header>
      <h3 class="text-sm font-bold text-slate-600">
        Fornecedor: <span class="text-orange-600 uppercase">{{ provider && provider.provider_name ? provider.provider_name : "" }}</span>
      </h3>
    </template>

    <!-- RESUMO DE NF-e -->
    <div class="mt-8 break-inside-avoid shadow-sm border border-slate-200 rounded-3xl overflow-hidden">
      <!-- TÍTULO DO RESUMO -->
      <div class="bg-slate-800 text-white px-8 py-5 flex items-center justify-between">
        <div class="flex items-center gap-3">
          <v-icon color="orange" size="24">mdi-file-percent</v-icon>
          <span class="text-sm font-bold uppercase tracking-widest italic">RESUMOS DE FATURAMENTO / NF-e</span>
        </div>
        <span class="text-[9px] font-black text-slate-400 uppercase tracking-[0.2em]">{{ data.result ? data.result.length : 0 }} ITENS</span>
      </div>

      <!-- TABELA DE ITENS -->
      <div class="p-0">
        <table class="w-full text-left border-collapse">
          <thead>
            <tr class="bg-slate-50 border-b border-slate-200">
              <th class="p-6 text-[10px] font-black text-slate-500 uppercase tracking-widest w-1/2">Descrição do Item</th>
              <th class="p-6 text-[10px] font-black text-slate-500 uppercase tracking-widest text-right">Volume (Litros)</th>
              <th class="p-6 text-[10px] font-black text-slate-500 uppercase tracking-widest text-right">Valor Total Acumulado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in data.result" :key="i" class="border-b border-slate-100 last:border-0 hover:bg-slate-50 transition-colors">
              <td class="p-6">
                <div class="flex items-center gap-4">
                  <div class="h-2 w-2 rounded-full bg-orange-500"></div>
                  <span class="text-sm font-bold text-slate-700 uppercase leading-tight">{{ item.item_description_desc }}</span>
                </div>
              </td>
              <td class="p-6 text-right whitespace-nowrap text-slate-600 font-medium">
                <span class="text-base font-black text-slate-800 tracking-tight">{{ item.totalLiters ? realMaskII(item.totalLiters.toFixed(3)) : 0 }}</span>
                <span class="ml-1 text-[10px] font-black text-slate-400 uppercase">Lts</span>
              </td>
              <td class="p-6 text-right whitespace-nowrap">
                <span class="text-base font-black text-orange-600 font-mono tracking-tighter">R$ {{ item.totalValue ? realMask(item.totalValue.toFixed(2)) : 0 }}</span>
              </td>
            </tr>
          </tbody>
          <!-- TOTAL BRUTO -->
          <tfoot class="bg-slate-900 text-white font-black border-t border-slate-700">
            <tr>
              <td class="p-8 text-lg uppercase tracking-widest">TOTAL FINAL CONSOLIDADO</td>
              <td class="p-8 text-right text-xl tracking-tighter">
                {{ data.resume.finalLiters ? realMaskII(data.resume.finalLiters.toFixed(3)) : 0 }}
                <span class="text-[10px] font-medium text-slate-500 ml-1">LITROS</span>
              </td>
              <td class="p-8 text-right text-3xl text-orange-400 font-mono tracking-tighter">
                <span class="text-sm font-medium mr-2 text-slate-500 whitespace-nowrap">R$</span>
                {{ data.resume.finalValue ? realMask(data.resume.finalValue.toFixed(2)) : 0 }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    
    <!-- FOOTER DE AUTENTICAÇÃO -->
    <footer class="mt-20 border-t border-slate-100 pt-10 flex justify-between items-end">
       <div class="flex flex-col gap-1">
          <span class="text-[9px] font-black text-slate-300 uppercase tracking-widest">Gerado em: {{ new Date().toLocaleString() }}</span>
          <span class="text-[9px] font-black text-slate-300 uppercase tracking-widest">SCI SYSTEM - MÓDULO DE FATURAMENTO</span>
       </div>
       <div class="w-64 h-px bg-slate-200 relative mb-4">
          <span class="absolute -top-10 left-1/2 -translate-x-1/2 text-[10px] font-bold text-slate-400 uppercase whitespace-nowrap italic">Assinatura do Fornecedor</span>
       </div>
    </footer>
  </ReportLayoutModerno>
</template>

<script>
import helpers from "@/mixins/helpers";
import ReportLayoutModerno from "@/components/ReportLayoutModerno.vue";

export default {
  components: { ReportLayoutModerno },
  props: ["data", "filter", "prefecture", "provider"],
  mixins: [helpers],
  methods: {
    initialize() {
      this.helpers;
    },
  },
};
</script>

<style></style>